<div>
        <ng-container *ngFor="let item of rangeRating; let i = index">
                <mat-icon class="amber-fg">{{ iconForIndex(i) }}</mat-icon>
        </ng-container> 
</div>
<div *ngIf="comment" class="primary-300-fg">{{ comment }}</div>